import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientTimesheetsPage from "@/pages/client/ClientTimesheetsPage";

export const Route = createFileRoute("/client/timesheets")({
  head: () => pageHead("Client · Timesheets", "AKIVA client · timesheets portal.", "/client/timesheets", true),
  component: ClientTimesheetsPage,
});
